import { useEffect, useRef } from "react";
import {
  checkEmptyObject,
  getUrlParams,
} from "../../../../services/utils";
import {
  QueryParam
} from "../../../../models/enums";

export const useUpdateSearchOnChange = (props, queryParams, handleSearch, generateTags) => {
  const prevProps = useRef(props);

  const {
    module,
    ads,
    favoriteIds,
    configuration,
    controlFields,
    location,
  } = props;

  useEffect(() => {
    if (location !== prevProps.current.location) {
      const newQueryParams = getUrlParams(location.search, QueryParam.searchQuery) || {};
      queryParams.current = newQueryParams;

      if (newQueryParams.text) {
        const prevParams = getUrlParams(prevProps.current.location.search, QueryParam.searchQuery);

        if (!prevParams || prevParams.text !== newQueryParams.text) {
          handleSearch();
          return;
        }
      }
    }

    if (
      configuration !== prevProps.current.configuration ||
      controlFields !== prevProps.current.controlFields
    ) {
      generateTags();
    }

    // Scoped configuration datasets (makes, subcategories, resolved locations,
    // location levels, ...) land one by one; they only change the tag labels and
    // slugs, never the search itself. Don't re-run the search for them. `ads`
    // is deliberately not compared: it changes when a search result lands,
    // which is never a reason to search again.
    const onlyConfigurationChanged =
      configuration !== prevProps.current.configuration &&
      module === prevProps.current.module &&
      favoriteIds === prevProps.current.favoriteIds &&
      controlFields === prevProps.current.controlFields &&
      location === prevProps.current.location;

    if (onlyConfigurationChanged) {
      prevProps.current = props;
      return;
    }

    const shouldSearch =
      (!checkEmptyObject(ads) &&
        favoriteIds !== prevProps.current.favoriteIds) ||
      module !== prevProps.current.module ||
      location.search !== prevProps.current.location.search;

    //if (shouldSearch) { // Hotfix to decrease number of lifecycles
    handleSearch();
    //}

    // Remember the current props for the next run:
    prevProps.current = props;
  }, [
    module,
    ads != null,
    favoriteIds,
    configuration,
    controlFields,
    location
  ]);

}


// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/hooks/useUpdateSearchOnChange.ts